var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:_vm.typeClass,on:{"click":_vm.removeNotif}},[_c('h1',[_vm._v(_vm._s(_vm.notif.title))]),_c('p',[_vm._v(_vm._s(_vm.notif.comment))])])}
var staticRenderFns = []

export { render, staticRenderFns }